import App from '../components/app'
import DivBottom from '../components/divBottom'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../admin/components/navbarBottomAdmin'
import NavbarNotAuth from '../components/navbarNotAuth'

function Firenze() {
    // eslint-disable-next-line no-lone-blocks
    {
        localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarBottomAdmin /> <NavbarTopAdmin /></div>
        : <NavbarNotAuth />
    }


    return (<>
        <div style={{ marginTop: '6rem' }}></div>
        <App />
        <div style={{ marginBottom: '50px' }}>
            <div style={{
                textAlign: 'center',
                padding: '3rem 0rem 1rem 0rem'
            }}>
                <h1>Firenze</h1>
                <h5 style={{ color: 'grey', position: 'relative' }}>TOSCANA
                    <span style={{
                        position: 'absolute',
                        left: '1rem',
                        backgroundColor: 'maroon',
                        color: 'whitesmoke',
                        padding: '3px',
                        borderRadius: '5px'
                    }}>ARTE
                    </span>
                </h5>
            </div>

            <div className='mt-1'>
                <div className='galleria container-fluid'>
                    <div className='gbox1'>
                        <img src={require('../image/domenico-loia-unsplash.jpg')} height='100%' width='100%' alt='' />
                    </div>
                    <div className='gbox2'>
                        <h4>La culla del rinascimento</h4><hr />
                        <p className='mt-3'>
                            <b>Firenze</b> è una delle città più belle d'Italia e sicuramente uno di quei luoghi da vedere almeno una volta nella vita!
                            I suoi musei, che attirano migliaia di turisti, sono tra i più belli al mondo e la sua storia è ancora affascinante e coinvolgente.
                        </p>
                        <hr />
                        <p>
                            Capoluogo della Toscana, <b>patrimonio UNESCO</b> e città europea della cultura, Firenze è anche un importantissimo centro
                            universitario.<br />
                            Unanimemente etichettata come <b>capitale mondiale dell'arte e dell'architettura</b> e meta di turisti da tutto
                            il mondo, Firenze è soprattutto famosa per la presenza di opere artistiche, letterarie e scientifiche di inestimabile valore
                            lasciate da eccelse menti del passato: <b>Dante</b>, <b>Petrarca</b>, <b>Leonardo</b>, <b>Giotto</b>, <b>Donatello</b>,
                            <b> Michelangelo</b> e tanti altri artisti storici.<br />
                            Luogo d'origine del <b>Rinascimento</b>, la città conserva ancora intatte la grazia e l'eleganza che caratterizzano il
                            suo stile architettonico.
                            Antichi palazzi, sculture, affreschi e arte ovunque, passeggiare tra le vie di Firenze è davvero un'esperienza
                            straordinaria!<br />
                            E' una città ricca di miti e leggende popolari che vengono tramandati di generazione in
                            generazione e che narrano di amori, tradimenti, tragedie, ma esistono anche satire e racconti comici.
                        </p>
                    </div>
                    <img src={require("../image/alexandra-smielova-unsplash.jpg")} className='galleria_immagine addImg' alt='' />
                    <img src={require("../image/matteo-lezzi-Ae-ZPRO-Bk4-unsplash.jpg")} className='galleria_immagine addImg' alt='' />

                </div>

                <p className='m-3'>
                    <b>Firenze</b> può dare veramente tanto...turisticamente parlando. Risulta normale rimanere a bocca aperta ammirando
                    la maestosità del Duomo, le grandiose sculture degli <b>Uffizi</b>, l'eleganza di <b> Ponte Vecchio</b>,
                    oppure guardando, da uno dei punti panoramici, le innumerevoli ricchezze artistiche e architettoniche della <b>culla del Rinascimento</b>.
                </p>

                <div className='container mt-2'>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>COSA VEDERE A FIRENZE</h1>
                        <img src={require('../image/fab-lentz-unsplash.jpg')} className='imgCittà' alt='' />
                        <ul className='text-start mt-3'>
                            <li>
                                <b>Piazzale Michelangelo</b>, regala un panorama spettacolare del cuore cittadino e se ci arrivate al tramonto o alla sera, le luci di Firenze vi ammalieranno.
                            </li>
                            <li>
                                <b>Galleria degli uffizi</b>, un museo meraviglioso in un palazzo stupendo. Raccoglie opere di inestimabile valore
                                appartenenti a scultori e pittori del calibro di <b>Giotto</b>, <b>Tiziano</b>, <b>Da Vinci</b>, <b>Raffaello</b>, <b>Botticelli</b> e molti altri.
                            </li>
                            <li>
                                <b>Duomo Santa Maria del Fiore</b>, non ci sono parole per descrivere questa spettacolare cattedrale con la più grande cupola in muratura al mondo.
                                E' anche la quarta chiesa europea per ordine di grandezza!
                            </li>
                            <li>
                                <b>Piazza del duomo</b>, passeggiare in questa piazza è come essere trasportati in un dipinto rinascimentale.
                            </li>
                            <li>
                                <b>Ponte vecchio</b>, costruzione storica sopra il fiume <b>Arno</b> e attraversato da un numero infinito di turisti,
                                ci si passa per raggiungere Palazzo Pitti, piazza del Duomo o Palazzo della Signoria.
                            </li>
                            <li>
                                <b>Campanile di Giotto</b>, monumentale campanile mirabile in tutta la sua grandezza.
                                E' possibile visitarlo anche se, per raggiungere la cima, i gradini sono tanti ma Giotto merita lo sforzo.
                            </li>
                        </ul>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>CATTEDRALE DI SANTA MARIA DEL FIORE</h1>
                        <img src={require('../image/alexandra-smielova-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <br />
                        <p className='mt-3'>
                            La Cattedrale di <b>Santa Maria del Fiore</b> o Duomo di Firenze è un monumento dedicato alla Vergine dei Fiori.
                            Inizialmente progettata da <b>Arnolfo di Cambio</b>, l'edificazione della Cattedrale di Santa Maria del Fiore
                            iniziò nel secolo XIII. Per completare la cattedrale ci vollero 140 anni
                            e il progetto fu elaborato da diversi architetti come <b>Giotto</b>, <b>Andrea Pisano</b>, <b>Alberto Arnoldi</b>.
                            La cupola della cattedrale, che si erge per un'altezza di 116 metri fu progettata da <b>Filippo Brunelleschi </b>
                            che, dopo aver vinto un concorso di progettazione, fu incaricato di ideare e costruire la cupola della chiesa.<br />
                            La cattedrale di Santa Maria del Fiore risulta essere la quarta cattedrale più grande d'Europa,
                            ed è Patrimonio dell'Umanità dell'<b>UNESCO</b>.
                            Splendidi affreschi, dipinti, statue e disegni in vetro colorato, porte ornate e complessi mosaici rendono il duomo
                            un'opera d'arte ispiratrice, sia internamente che esternamente e visitarlo risulterà un'esperienza mozzafiato!<br />
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>PONTE VECCHIO</h1>
                        <img src={require('../image/domenico-loia-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <br />
                        <p className='mt-3'>
                            È uno dei maggiori e più conosciuti <b>ponti storici</b> d'Italia. Se andate a Firenze non potete rinunciare
                            di fare due passi lungo <b>Ponte Vecchio</b> che, da come evince il nome, è il ponte più vecchio della città.
                            Di epoca romana, quasto ponte fu distrutto diverse volte dalle alluvioni ma fu sempre ricostruito.
                            Attualmente è una meta imperdibile dei turisti che visitano Firenze e che non perdono l'occasione per
                            farsi un selfie, ricco anche di negozi con merce di qualità.<br />
                            Fra tutte le bellezze di Firenze, Ponte Vecchio è una delle più iconiche e suggestive!<br />
                            Impossibile lasciare la città senza aver passeggiato fra le botteghe, incantandosi dinanzi alle
                            meravigliose creazioni orafe o contemplando l'acqua impetuosa che scorre al di sotto.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>PIAZZA DELLA SIGNORIA</h1>
                        <img src={require('../image/anton-volnuhin-dIUfDtU-qkw-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <br />
                        <p className='mt-3'>
                            In questa <b>storica piazza</b> troverete dei monumenti importanti come <b>Palazzo Vecchio</b>,
                            la <b>Loggia dei Lanzi</b> e le <b>Gallerie degli Uffizi</b>.
                            Rappresenta inoltre il cuore politico della città e attraversarla è come fare un tuffo nel passato.
                            Circondata da palazzi storici meravigliosi e opere d'arte a cielo aperto, questa piazza offre ai numerosi turisti
                            la possibilità di trovarsi in un museo a 360 gradi.
                            Rimarrete estasiati davanti al <b>David di Michelangelo</b> e alla <b>Fontana del Nettuno</b>!<br />
                            In ogni angolo di questa piazza è nascosta una storia e l'atmosfera è magicamente incantevole.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>PALAZZO PITTI</h1>
                        <img src={require("../image/robert-katzki-bJiKiI8DhJI-unsplash.jpg")} className='galleria_immagine addImg' alt='' />
                        <br />
                        <p className='mt-3'>
                            E' un maestoso palazzo rinascimentale sito nelle vicinanze di Ponte Vecchio.
                            Come conseguenza dell'unità d'Italia, la struttura divenne Palazzo Reale per Casa Savoia
                            e Firenze fu nominata capitale del Regno d'Italia.
                            Nel 1919 Vittorio Emanuele III donò il palazzo allo Stato e divenne un museo.<br />
                            Internamente sono stati creati diversi musei tra cui la <b>Galleria Palatina</b>, dove potrete ammirare i capolavori
                            di <b>Raffaello e Tiziano</b>, gli Appartamenti Reali, la galleria d'Arte Moderna, il museo della Moda e
                            del Costume, il museo delle Porcellane e il museo delle Carrozze.<br />
                            Un palazzo affascinante, un'esperienza da non perdere nella storia e nella cultura di Firenze.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>GASTRONOMIA</h1>
                        <img src={require('../image/alex-presa-sMLBjtKcYoA-unsplash.jpg')} className='imgCittà' alt='' />
                        <br />
                        <ul className='mt-3 text-start'>
                            <li>
                                <b>Bistecca alla fiorentina</b>. Per essere veramente una fiorentina deve avere queste caratteristiche:
                                deve pesare minimo 1 kg e 100 grammi, va servita al sangue e con l'osso.
                                Lo spessore dovrebbe essere di almeno 3 dita. La carne utilizzata è la chianina proveniente dalla Val di Chiana.
                            </li>
                            <li>
                                <b>Finocchiona</b>, è un insaccato a base di carne di maiale stagionato e aromatizzato
                                al finocchio. Da assaporare come antipasto insieme al pane sciapo o con altre specialità fiorentine come
                                i crostini ai fegatini.
                            </li>
                            <li>
                                <b>La ribollita</b>, zuppa a base di verdure e pane raffermo.
                            </li>
                            <li>
                                <b>Pici all'aglione</b>, sono un primo piatto realizzato con un impasto di farina e acqua molto
                                servito in tutto il centro Italia. L'olio extravergine d'oliva, l'aglione e il sugo di pomodoro
                                saranno il condimento per quasta pietanza.
                            </li>
                            <li>
                                <b>Panino con lampredotto</b>, è semplicemente un panino con una frattaglia
                                che viene bollita per ore nel brodo.
                            </li>
                            <li>
                                <b>Vin Santo e Cantucci</b>, sono dolci secchi alle mandorle accompagnati da un vino dolce
                                prodotto da uve lasciate appassire dopo la raccolta.
                            </li>
                        </ul>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>FIESOLE</h1>
                        <img src={require('../image/heloise-delbos-bite6uTCb50-unsplash.jpg')} className='imgCittà' alt='' />
                        <br />
                        <p className='mt-3'>
                            <b>Fiesole</b>, posta a 300 metri di altitudine, domina il centro di Firenze che dista solo 5 Km.
                            Il <b>panorama</b> è qualcusa di unico e incantevole!<br />
                            Il paesaggio è costellato da cipressi, olivi, da macchie di bosco e ville
                            inserite in questo quadro come fossero disegnate da una mano impressionista.
                            Il <b>Convento di San Francesco</b>, sul colle di Fiesole, è un luogo ameno, di preghiera e di riflessione
                            con una bellissima vista e un'atmosfera incantata.
                        </p>
                    </div>
                </div>
            </div>

            <DivBottom />
        </div >
    </>
    )
}
export default Firenze